import { render, staticRenderFns } from "./HowTos.vue?vue&type=template&id=16ca90ca"
import script from "./HowTos.vue?vue&type=script&lang=ts"
export * from "./HowTos.vue?vue&type=script&lang=ts"
import style0 from "./HowTos.vue?vue&type=style&index=0&id=16ca90ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports